import React, { useState, useEffect, useRef } from 'react';
import { lockScroll, unlockScroll } from '../utils/scrollbarUtils';
import api from '../utils/api';
import wsService from '../utils/websocket';
import bottomNavBg from '../assets/icons/common/bottomNav.png';
import menutagKoreanPopular from '../assets/icons/menutag/korean/popular.png';
import menutagKoreanRecommend from '../assets/icons/menutag/korean/recommend.png';
import menutagKoreanNew from '../assets/icons/menutag/korean/new.png';
import menutagKoreanRequiredTag from '../assets/icons/menutag/korean/requiredTag.png';
import menutagKoreanOptionalTag from '../assets/icons/menutag/korean/optionalTag.png';
import menutagEnglishPopular from '../assets/icons/menutag/english/popular.png';
import menutagEnglishRecommend from '../assets/icons/menutag/english/recommend.png';
import menutagEnglishNew from '../assets/icons/menutag/english/new.png';
import menutagEnglishRequiredTag from '../assets/icons/menutag/english/requiredTag.png';
import menutagEnglishOptionalTag from '../assets/icons/menutag/english/optionalTag.png';
import menutagJapanPopular from '../assets/icons/menutag/japan/popular.png';
import menutagJapanRecommend from '../assets/icons/menutag/japan/recommend.png';
import menutagJapanNew from '../assets/icons/menutag/japan/new.png';
import menutagJapanRequiredTag from '../assets/icons/menutag/japan/requiredTag.png';
import menutagJapanOptionalTag from '../assets/icons/menutag/japan/optionalTag.png';
import menutagChinaPopular from '../assets/icons/menutag/china/popular.png';
import menutagChinaRecommend from '../assets/icons/menutag/china/recommend.png';
import menutagChinaNew from '../assets/icons/menutag/china/new.png';
import menutagChinaRequiredTag from '../assets/icons/menutag/china/requiredTag.png';
import menutagChinaOptionalTag from '../assets/icons/menutag/china/optionalTag.png';

const menutagMap = {
  korean: { popular: menutagKoreanPopular, recommend: menutagKoreanRecommend, new: menutagKoreanNew, requiredTag: menutagKoreanRequiredTag, optionalTag: menutagKoreanOptionalTag },
  english: { popular: menutagEnglishPopular, recommend: menutagEnglishRecommend, new: menutagEnglishNew, requiredTag: menutagEnglishRequiredTag, optionalTag: menutagEnglishOptionalTag },
  japan: { popular: menutagJapanPopular, recommend: menutagJapanRecommend, new: menutagJapanNew, requiredTag: menutagJapanRequiredTag, optionalTag: menutagJapanOptionalTag },
  china: { popular: menutagChinaPopular, recommend: menutagChinaRecommend, new: menutagChinaNew, requiredTag: menutagChinaRequiredTag, optionalTag: menutagChinaOptionalTag },
};

const MenuOptionsBottomSheet = ({ isOpen, onClose, menuItem, selectedLanguage = 'ko', onAddToCart }) => {
  // Translations
  const translations = {
    ko: {
      price: '가격',
      quantity: '수량',
      add: '담기'
    },
    en: {
      price: 'Price',
      quantity: 'Quantity',
      add: 'Add'
    },
    ja: {
      price: '価格',
      quantity: '数量',
      add: '追加'
    },
    zh: {
      price: '价格',
      quantity: '数量',
      add: '放入购物车'
    }
  };
  
  const t = translations[selectedLanguage] || translations.ko;
  const [selectedOptions, setSelectedOptions] = useState({});
  const [quantity, setQuantity] = useState(1);
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [actualPrices, setActualPrices] = useState({}); // 실제 메뉴 가격 저장
  const [isScrolling, setIsScrolling] = useState(false);
  const [prevQuantity, setPrevQuantity] = useState(1);
  const [isQuantityAnimating, setIsQuantityAnimating] = useState(false);
  const [animationDirection, setAnimationDirection] = useState('');
  const [radioAnimating, setRadioAnimating] = useState(null);
  const [checkboxAnimating, setCheckboxAnimating] = useState(null);

  // 디버그: checkboxAnimating 상태 모니터링
  useEffect(() => {
    console.log('[상태 변경] checkboxAnimating:', checkboxAnimating);
  }, [checkboxAnimating]);

  const [displayPrice, setDisplayPrice] = useState('0');
  const [prevPrice, setPrevPrice] = useState('0');
  const [priceAnimating, setPriceAnimating] = useState(false);
  const [animationKey, setAnimationKey] = useState(0);
  const [isPriceIncreasing, setIsPriceIncreasing] = useState(true);
  const [isPreparingAnimation, setIsPreparingAnimation] = useState(false);
  const [preparedPrice, setPreparedPrice] = useState('0');
  const priceAnimationTimeoutRef = useRef(null);
  const scrollTimeoutRef = useRef(null);
  const rippleTimeoutRef = useRef(null);
  const hasMoved = useRef(false);

  // WebSocket 장바구니 동기화는 orderPage와 cartDrawer에서 처리
  // menuOptionsBottomSheet는 장바구니 추가만 담당

  // 리플 효과 생성
  const createRipple = (element, event) => {
    const ripple = document.createElement('span');
    ripple.classList.add('ripple');

    // 요소의 크기 가져오기
    const rect = element.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 2;

    // 정중앙에 배치
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = '50%';
    ripple.style.top = '50%';
    ripple.style.marginLeft = `-${size / 2}px`;
    ripple.style.marginTop = `-${size / 2}px`;

    // 리플 추가
    element.appendChild(ripple);

    // 즉시 클릭 애니메이션 시작
    ripple.classList.add('click');

    // 애니메이션 종료 후 제거
    ripple.addEventListener('animationend', () => {
      ripple.remove();
    }, { once: true });
  };

  // 선택 메뉴의 실제 가격 조회
  const loadActualPrices = async () => {
    try {
      // 모든 옵션의 itemCode 수집
      const itemCodes = [];
      menuItem.options.forEach(optionGroup => {
        const optionItems = optionGroup.choices || optionGroup.items || [];
        optionItems.forEach(item => {
          if (item.itemCode) {
            itemCodes.push(item.itemCode);
          }
        });
      });

      if (itemCodes.length > 0) {
        const response = await api.getMenuPrices(itemCodes);
        if (response.success) {
          setActualPrices(response.prices);
        }
      }
    } catch (error) {
      console.error('실제 가격 조회 실패:', error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      // 먼저 초기 상태로 설정
      setIsAnimating(false);
      setIsVisible(true);

      // body 스크롤 방지 (스크롤 위치 유지)
      lockScroll();

      // 히스토리 상태 추가
      window.history.pushState({ optionMenu: true }, '');

      // 선택 메뉴인 경우 실제 가격 조회
      if (menuItem?.menuType === '선택' && menuItem.options) {
        loadActualPrices();
      }
      
      // 필수 옵션의 첫 번째 항목 자동 선택
      if (menuItem && menuItem.options) {
        const defaultSelections = {};
        
        // 새 형식 (배열) 체크
        if (Array.isArray(menuItem.options)) {
          menuItem.options.forEach((optionGroup) => {
            const optionItems = optionGroup.choices || optionGroup.items || [];
            if (optionGroup.auto_include) {
              // METACITY 02 세트: 구성품 전량 자동 선택(손님 선택 없이 장바구니/주문에 포함)
              optionItems.forEach((choice, idx) => {
                const optionKey = `${optionGroup.name || optionGroup.option_group_name}_${idx}`;
                defaultSelections[optionKey] = choice;
              });
              return;
            }
            // 라디오 버튼(required, 단 count 모드 QTY>=2는 제외 — 빈 상태로 시작)
            const isRadio = optionGroup.required && !isCountGroup(optionGroup);
            if (isRadio && optionItems.length > 0) {
              // 첫 번째 선택지를 기본값으로 설정
              const firstChoice = optionItems[0];
              const optionKey = `${optionGroup.name || optionGroup.option_group_name}_0`;
              defaultSelections[optionKey] = firstChoice;
            }
          });
        } 
        // 기존 형식 (객체)
        else {
          Object.entries(menuItem.options).forEach(([optionTitle, optionData], index) => {
            if (optionData.type === 'required' && optionData.items.length > 0) {
              defaultSelections[index] = optionData.items[0].name;
            }
          });
        }
        
        setSelectedOptions(defaultSelections);
      }
      
      // 다음 프레임에서 애니메이션 시작
      setTimeout(() => {
        setIsAnimating(true);
      }, 10);
    } else {
      setIsAnimating(false);
      
      const timer = setTimeout(() => {
        setIsVisible(false);
        setSelectedOptions({});
        setQuantity(1);
        // 애니메이션이 완료된 후 body 스크롤 복원
        unlockScroll();
      }, 150);
      return () => {
        clearTimeout(timer);
        // 가격 애니메이션 타이머 정리
        if (priceAnimationTimeoutRef.current) {
          clearTimeout(priceAnimationTimeoutRef.current);
        }
      };
    }
  }, [isOpen, menuItem]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);
      
      // 기존 타이머 취소
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      // 50ms 후에 스크롤 종료 상태로 변경 (더 빠른 반응을 위해)
      scrollTimeoutRef.current = setTimeout(() => {
        setIsScrolling(false);
      }, 50);
    };

    const scrollElement = document.querySelector('.bottom-sheet-content');
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [isVisible]);

  useEffect(() => {
    const handlePopState = (e) => {
      if (isOpen) {
        e.preventDefault();
        onClose();
      }
    };

    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    const scaleUI = () => {
      const wrapper = document.querySelector('.bottom-sheet-wrapper');
      if (wrapper) {
        const viewportWidth = window.innerWidth;
        const scale = Math.min(viewportWidth / 360, 1.5);
        wrapper.style.zoom = scale;
      }
    };
    
    if (isVisible) {
      scaleUI();
      window.addEventListener('resize', scaleUI);
    }
    
    return () => {
      window.removeEventListener('resize', scaleUI);
    };
  }, [isVisible]);

  // 가격 변경 시 슬롯머신 효과
  useEffect(() => {
    if (!menuItem || !isVisible) return;
    
    const newPrice = (calculateTotalPrice() * quantity).toLocaleString();
    if (newPrice !== displayPrice) {
      // 진행 중인 애니메이션 타이머 취소
      if (priceAnimationTimeoutRef.current) {
        clearTimeout(priceAnimationTimeoutRef.current);
      }
      
      // 준비 단계 없이 바로 시작
      setPrevPrice(displayPrice);
      setPreparedPrice(newPrice);
      setAnimationKey(prev => prev + 1);
      
      // 가격 증가/감소 판단
      const prevPriceNum = parseInt(displayPrice.replace(/,/g, '')) || 0;
      const newPriceNum = parseInt(newPrice.replace(/,/g, '')) || 0;
      const priceIncreasing = newPriceNum > prevPriceNum;
      setIsPriceIncreasing(priceIncreasing);
      
      // 즉시 애니메이션 시작
      setPriceAnimating(true);
      
      // 실제 가격 업데이트는 50ms 후
      setTimeout(() => {
        setDisplayPrice(newPrice);
      }, 50);
      
      // 애니메이션 시간 계산 (더 부드럽게 조정)
      const totalAnimationTime = 600; // 고정된 애니메이션 시간
      
      priceAnimationTimeoutRef.current = setTimeout(() => {
        setPriceAnimating(false);
      }, totalAnimationTime);
    }
  }, [selectedOptions, quantity, menuItem, isVisible, displayPrice]);

  if (!isVisible) return null;

  const handleOptionChange = (groupIndex, itemName, isMultiple) => {
    // 새 형식 (배열)의 필수 옵션 확인
    if (Array.isArray(menuItem.options)) {
      const optionGroup = menuItem.options[groupIndex];
      if (optionGroup && optionGroup.required) {
        // 필수 옵션은 선택 해제 불가
        const currentKey = `${optionGroup.name}_${groupIndex}`;
        const currentSelected = selectedOptions[currentKey];
        if (currentSelected && currentSelected.name === itemName) {
          // 이미 선택된 필수 옵션을 다시 클릭한 경우 무시
          return;
        }
        // 필수 옵션 변경 처리
        const optionItems = optionGroup.choices || optionGroup.items || [];
        const choice = optionItems.find(c => (c.name || c.option_name) === itemName);
        if (choice) {
          setSelectedOptions(prev => ({
            ...prev,
            [currentKey]: choice
          }));
          // 애니메이션 트리거
          setRadioAnimating(`${groupIndex}-${itemName}`);
          setTimeout(() => setRadioAnimating(null), 300);
          return;
        }
      }
    }
    
    if (!isMultiple) {
      // 라디오 버튼인 경우 애니메이션 트리거
      // 현재 선택된 라디오에도 애니메이션 적용 (Off로 전환되는 것)
      const currentSelected = selectedOptions[groupIndex];
      if (currentSelected && currentSelected !== itemName) {
        setRadioAnimating(`${groupIndex}-${currentSelected}`);
      }
      // 새로 선택되는 라디오에 애니메이션 적용 (On으로 전환되는 것)
      setTimeout(() => {
        setRadioAnimating(`${groupIndex}-${itemName}`);
        setTimeout(() => setRadioAnimating(null), 300);
      }, 10);
    } else {
      // 체크박스인 경우 애니메이션 트리거
      setCheckboxAnimating(`${groupIndex}-${itemName}`);
      setTimeout(() => setCheckboxAnimating(null), 400);
    }
    
    setSelectedOptions(prev => {
      if (isMultiple) {
        const currentGroup = prev[groupIndex] || [];
        if (currentGroup.includes(itemName)) {
          return {
            ...prev,
            [groupIndex]: currentGroup.filter(item => item !== itemName)
          };
        } else {
          return {
            ...prev,
            [groupIndex]: [...currentGroup, itemName]
          };
        }
      } else {
        return {
          ...prev,
          [groupIndex]: itemName
        };
      }
    });
  };

  const calculateTotalPrice = () => {
    if (!menuItem) return 0;

    // 선택 메뉴 타입 체크
    const isChoiceType = menuItem?.menuType === '선택';

    // 선택 메뉴인 경우 선택한 옵션의 실제 가격 사용
    if (isChoiceType) {
      let choicePrice = 0;

      if (menuItem.options && Array.isArray(menuItem.options)) {
        Object.entries(selectedOptions).forEach(([key, choice]) => {
          if (choice && choice.itemCode && actualPrices[choice.itemCode]) {
            // DB에서 조회한 실제 가격 사용
            choicePrice = actualPrices[choice.itemCode];
          } else if (choice && choice.price) {
            // 실제 가격이 없으면 옵션에 설정된 가격 사용 (fallback)
            choicePrice = parseInt(choice.price.toString().replace(/[^0-9]/g, '')) || 0;
          }
        });
      }

      return choicePrice;  // 개당 가격만 반환
    }

    // 고정세트 메뉴 체크
    const isFixedSet = menuItem?.menuType === '고정세트';

    // 고정세트인 경우 DB에 이미 총 가격이 계산되어 있으므로 옵션 가격을 더하지 않음
    if (isFixedSet) {
      const price = menuItem[selectedLanguage]?.price || menuItem.ko?.price || menuItem.price || '0';
      const priceStr = typeof price === 'number' ? price.toString() : price;
      const basePrice = parseInt(priceStr.replace(/[^0-9]/g, '')) || 0;
      return basePrice;  // 개당 가격만 반환
    }

    // 일반 메뉴 및 변동세트 메뉴의 경우 기존 로직
    // Get price from multilingual structure
    const price = menuItem[selectedLanguage]?.price || menuItem.ko?.price || menuItem.price || '0';
    // Convert to string if it's a number
    const priceStr = typeof price === 'number' ? price.toString() : price;
    const basePrice = parseInt(priceStr.replace(/[^0-9]/g, '')) || 0;
    let optionsPrice = 0;

    if (menuItem.options) {
      // 새 형식 (배열) 체크
      if (Array.isArray(menuItem.options)) {
        // selectedOptions가 {optionName_index: choice} 형태
        Object.entries(selectedOptions).forEach(([key, choice]) => {
          if (choice) {
            // OKDC는 option_price, 기존은 price 필드 사용
            const priceValue = choice.option_price ?? choice.price;
            if (priceValue !== undefined && priceValue !== null) {
              // 가격이 문자열로 저장되어 있을 수 있으므로 parseInt 사용
              const price = parseInt(priceValue.toString().replace(/[^0-9]/g, '')) || 0;
              optionsPrice += price;
            }
          }
        });
      }
      // 기존 형식 (객체)
      else {
        Object.entries(menuItem.options).forEach(([optionTitle, optionData], index) => {
          const selected = selectedOptions[index];

          if (optionData.type === 'required' && selected) {
            const option = optionData.items.find(item => item.name === selected);
            if (option && option.price) {
              optionsPrice += option.price;
            }
          } else if (optionData.type === 'optional' && Array.isArray(selected)) {
            selected.forEach(optionName => {
              const option = optionData.items.find(item => item.name === optionName);
              if (option && option.price) {
                optionsPrice += option.price;
              }
            });
          }
        });
      }
    }

    return basePrice + optionsPrice;  // 개당 가격만 반환 (옵션 포함)
  };

  const handleQuantityChange = (newQuantity, direction) => {
    if (isQuantityAnimating) return;
    
    setPrevQuantity(quantity);
    setQuantity(newQuantity);
    setAnimationDirection(direction);
    setIsQuantityAnimating(true);
    
    setTimeout(() => {
      setIsQuantityAnimating(false);
      setAnimationDirection('');
    }, 150);
  };

  // "정확히 N개 선택" 모드 (metacity QTY>=2).
  //
  // ※ 이 필드는 metacity 전용이 아니다. wowpos 도 같은 이름(snake_case max_select)을 쓴다.
  //    처음 만들 때 "metacity 전용"으로 잘못 단정해, wowpos 의 무제한 표시값(99)이
  //    "99개를 골라야 한다"로 읽히면서 담기 버튼이 잠기는 일이 있었다.
  //    지금은 wowpos 백엔드가 무제한을 null 로 내려보내 충돌하지 않는다
  //    (routes/wowpos.js 의 loadWowposMenuData).
  //    다른 POS 를 붙일 때도 "무제한 = null" 규약을 지킬 것.
  // function 선언(호이스팅) — 위쪽 useEffect(자동선택)에서 참조하므로 TDZ 방지 위해 화살표가 아닌 function 사용.
  function getSelectN(og) { return og && Number.isInteger(og.max_select) ? og.max_select : null; }
  function isCountGroup(og) { const n = getSelectN(og); return n !== null && n >= 2; }
  function groupSelectedCount(og, opts) {
    const prefix = `${og.name || og.option_group_name}_`;
    return Object.keys(opts).filter(k => k.startsWith(prefix)).length;
  }
  // count 모드 그룹은 정확히 N개 선택돼야 담기 가능
  function isOptionSelectionValid() {
    if (!Array.isArray(menuItem?.options)) return true;
    return menuItem.options.every(og => !isCountGroup(og) || groupSelectedCount(og, selectedOptions) === getSelectN(og));
  }

  const handleAddToCart = () => {
    // count 모드(정확히 N개) 미충족 시 차단
    if (!isOptionSelectionValid()) return;
    // 선택 메뉴 타입 체크
    const isChoiceType = menuItem?.menuType === '선택';

    // selectedOptions를 배열 형태로 변환 (일관성 있는 비교를 위해)
    const selectedOptionsArray = [];

    // groupId에서 option_type 찾기 위한 맵 생성
    // groupId는 "그룹명_아이템인덱스" 형태이므로, 그룹명만 추출해서 매칭
    const groupTypeMap = {};
    if (menuItem.options && Array.isArray(menuItem.options)) {
      menuItem.options.forEach((group) => {
        const groupName = group.option_group_name || group.name;
        groupTypeMap[groupName] = group.option_type;
      });
    }

    Object.entries(selectedOptions).forEach(([groupId, option]) => {
      if (option && typeof option === 'object') {
        // groupId에서 그룹명 추출 ("온도_0" → "온도")
        const groupName = groupId.split('_').slice(0, -1).join('_');
        const optionType = groupTypeMap[groupName] || '';

        // 라디오 버튼 옵션 (단일 선택)
        // OKDC는 option_name, 기존은 name 필드 사용
        if (option.name || option.option_name) {
          selectedOptionsArray.push({
            groupId: groupId,
            // 필드명 정규화
            name: option.name || option.option_name,
            price: option.price ?? option.option_price ?? 0,
            option_type: optionType,  // option_type 추가
            // OKDC 전송용 필드들
            sda_cls_cd: option.sda_cls_cd || '',
            sda_cd: option.sda_cd || option.option_id || '',
            sds_grp_cd: option.sds_grp_cd || '',
            sds_cls_cd: option.sds_cls_cd || '',
            sds_cd: option.sds_cd || option.option_id || '',
            sds_prod_cd: option.sds_prod_cd || '',
            ...option
          });
        }
        // 체크박스 옵션 (다중 선택)
        else if (Array.isArray(option)) {
          option.forEach(choice => {
            if (choice && (choice.name || choice.option_name)) {
              selectedOptionsArray.push({
                groupId: groupId,
                // 필드명 정규화
                name: choice.name || choice.option_name,
                price: choice.price ?? choice.option_price ?? 0,
                option_type: optionType,  // option_type 추가
                // OKDC 전송용 필드들
                sda_cls_cd: choice.sda_cls_cd || '',
                sda_cd: choice.sda_cd || choice.option_id || '',
                sds_grp_cd: choice.sds_grp_cd || '',
                sds_cls_cd: choice.sds_cls_cd || '',
                sds_cd: choice.sds_cd || choice.option_id || '',
                sds_prod_cd: choice.sds_prod_cd || '',
                ...choice
              });
            }
          });
        }
      }
    });

    console.log('선택된 옵션 배열:', selectedOptionsArray);
    console.log('메뉴 타입:', menuItem?.menuType);

    // 기존 장바구니 데이터 가져오기
    const existingCart = JSON.parse(localStorage.getItem('cartData') || '[]');
    
    // 같은 메뉴와 옵션을 가진 아이템이 있는지 확인
    const existingItemIndex = existingCart.findIndex(item => {
      // userId 체크 제거 - 모든 사용자의 같은 메뉴는 합쳐짐

      // 같은 메뉴인지 확인 (itemCode로 비교하는 것이 더 정확)
      const isSameMenu = menuItem.itemCode ? 
        (item.menuItem.itemCode === menuItem.itemCode) :
        (item.menuItem.id === menuItem.id);
      
      if (!isSameMenu) {
        return false;
      }
      
      // 선택된 옵션이 같은지 확인 (배열로 비교)
      const existingOptions = Array.isArray(item.selectedOptions) ? 
        item.selectedOptions : [];
      
      // 옵션 개수가 다르면 다른 아이템
      if (existingOptions.length !== selectedOptionsArray.length) {
        return false;
      }
      
      // 각 옵션의 itemCode와 groupId로 비교 (순서 무관)
      const sortOptions = (options) => {
        return options.map(opt => ({
          groupId: opt.groupId || '',
          itemCode: opt.itemCode || '',
          name: opt.name || ''
        })).sort((a, b) => {
          if (a.groupId !== b.groupId) return a.groupId.localeCompare(b.groupId);
          if (a.itemCode !== b.itemCode) return a.itemCode.localeCompare(b.itemCode);
          return a.name.localeCompare(b.name);
        });
      };
      
      const sortedExisting = sortOptions(existingOptions);
      const sortedNew = sortOptions(selectedOptionsArray);
      
      // 정렬된 옵션 비교
      return JSON.stringify(sortedExisting) === JSON.stringify(sortedNew);
    });
    
    let updatedCart;
    let itemToSend;  // 서버로 전송할 아이템

    if (existingItemIndex !== -1) {
      // 이미 같은 아이템이 있어도 새 아이템처럼 전송 (서버가 수량 병합 처리)
      updatedCart = [...existingCart];
      console.log('같은 메뉴 발견 - 서버로 수량 추가 요청:', quantity);
    } else {
      // 없으면 새 아이템 추가
      console.log('새 메뉴 추가');

      // 선택 메뉴인 경우 선택한 옵션을 독립적인 메뉴로 변환
      if (isChoiceType && selectedOptionsArray.length > 0) {
        const selectedOption = selectedOptionsArray[0]; // 선택 메뉴는 단일 선택
        console.log('========== 선택 메뉴 처리 ==========');
        console.log('선택된 옵션 정보:', selectedOption);
        console.log('옵션 가격 (raw):', selectedOption.price);
        console.log('옵션 가격 (parsed):', parseInt(selectedOption.price || '0'));
        console.log('수량:', quantity);

        // 선택한 옵션을 메인 메뉴로 만들기
        const optionAsMenuItem = {
          id: `union-${selectedOption.itemCode}`,
          itemCode: selectedOption.itemCode,
          menuType: null, // 선택한 옵션은 일반 메뉴로 처리
          ko: {
            name: selectedOption.name,
            price: selectedOption.price ? `${selectedOption.price}원` : '0원'
          },
          name: selectedOption.name,
          // 다국어 필드 추가
          name_ko: selectedOption.name,
          name_en: selectedOption.name,
          name_ja: selectedOption.name,
          name_zh: selectedOption.name,
          price: parseInt(selectedOption.price || '0'),
          basePrice: parseInt(selectedOption.price || '0'),
          options: null, // 옵션 없음
          hasOptions: false,
          image: menuItem.image // 원본 메뉴의 이미지 사용
        };

        console.log('생성된 독립 메뉴 아이템:', optionAsMenuItem);
        console.log('=====================================');

        const cartItem = {
          id: `item_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
          menuItem: optionAsMenuItem,
          selectedOptions: [], // 옵션 없음
          quantity: quantity,
          price: parseInt(selectedOption.price || '0'), // 선택한 옵션의 가격
          addedAt: new Date().toISOString(),
          isFromChoiceMenu: true, // 선택 메뉴에서 생성된 항목 표시
          timestamp: Date.now() // 동시 추가 시 병합을 위한 타임스탬프
        };
        updatedCart = [...existingCart, cartItem];
      } else {
        // 일반 메뉴 또는 세트 메뉴
        console.log('일반/세트 메뉴 추가');
        console.log('장바구니 추가 시 메뉴 정보:', menuItem);
        console.log('장바구니 추가 시 선택된 옵션:', selectedOptionsArray);

        // 메뉴 아이템에 다국어 필드가 있는지 확인하고 추가
        const menuItemWithLang = {
          ...menuItem,
          name_ko: menuItem.name_ko || menuItem.menu_name || menuItem.name,
          name_en: menuItem.name_en || menuItem.menu_name || menuItem.name,
          name_ja: menuItem.name_ja || menuItem.menu_name || menuItem.name,
          name_zh: menuItem.name_zh || menuItem.menu_name || menuItem.name
        };

        console.log('Adding to cart with language fields:', {
          name_ko: menuItemWithLang.name_ko,
          name_en: menuItemWithLang.name_en,
          name_ja: menuItemWithLang.name_ja,
          name_zh: menuItemWithLang.name_zh
        });

        const cartItem = {
          id: `item_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
          menuItem: menuItemWithLang,
          selectedOptions: selectedOptionsArray, // 배열로 저장
          quantity: quantity,
          price: calculateTotalPrice(), // 옵션 포함 총 가격
          addedAt: new Date().toISOString(),
          timestamp: Date.now() // 동시 추가 시 병합을 위한 타임스탬프
        };
        updatedCart = [...existingCart, cartItem];
      }
    }
    
    // LocalStorage에 저장 (낙관적 업데이트)
    localStorage.setItem('cartData', JSON.stringify(updatedCart));

    // 서버로 전송 (하이브리드)
    if (wsService.isSocketConnected()) {
      console.log('MenuOptions: 장바구니 아이템 추가 이벤트 전송');

      // 전송할 아이템 준비
      if (existingItemIndex !== -1) {
        // 기존 아이템이 있으면 현재 수량만 전송 (서버가 합산)
        itemToSend = {
          menuItem: menuItem,
          selectedOptions: selectedOptionsArray,
          quantity: quantity,  // 추가할 수량만 전송
          price: calculateTotalPrice(),
          addedAt: new Date().toISOString(),
          timestamp: Date.now(),
          isFromChoiceMenu: isChoiceType
        };
      } else {
        // 새 아이템은 마지막에 추가된 것 그대로 전송
        itemToSend = updatedCart[updatedCart.length - 1];
      }

      wsService.addCartItem(itemToSend);
    }

    // BroadcastChannel로 다른 탭에 알림
    try {
      const channel = new BroadcastChannel('cart_channel');
      channel.postMessage({ type: 'cart_updated' });
      channel.close();
    } catch (error) {
      console.log('BroadcastChannel not supported:', error);
    }

    console.log('Cart updated');

    // 장바구니 담기 완료 콜백 호출
    if (onAddToCart) {
      onAddToCart();
    }
    
    onClose();
  };

  return (
    <div className={`bottom-sheet ${isAnimating ? 'open' : ''}`}>
      <div className="bottom-sheet-wrapper">
        {menuItem && (
          <>
            <div className="bottom-sheet-content">
              <div className="menu-detail-section">
                {menuItem.image && (
                  <div className="menu-image-large">
                    <img src={menuItem.image} alt={menuItem[selectedLanguage]?.name || menuItem.ko?.name || menuItem.name} />
                  </div>
                )}
                
                <div className="menu-detail-info">
                  {menuItem.tags && menuItem.tags.length > 0 && (
                    <div className="menu-tags-detail">
                      {menuItem.tags.sort((a, b) => {
                        const order = { 'popular': 0, 'recommend': 1, 'new': 2 };
                        return order[a] - order[b];
                      }).map((tag, tagIndex) => (
                        <img 
                          key={tagIndex}
                          className="menu-tag-detail"
                          src={(() => {
                            const langPath = selectedLanguage === 'en' ? 'english' : selectedLanguage === 'ja' ? 'japan' : selectedLanguage === 'zh' ? 'china' : 'korean';
                            return menutagMap[langPath]?.[tag] || menutagMap[langPath]?.new;
                          })()}
                          alt={tag}
                        />
                      ))}
                    </div>
                  )}
                  
                  <div className="menu-text-wrapper">
                    <h2 className="menu-detail-name">{menuItem[`name_${selectedLanguage}`] || menuItem.name_ko || menuItem.name}</h2>
                    <p className="menu-detail-description">{menuItem[`description_${selectedLanguage}`] || menuItem.description_ko || menuItem.description || ''}</p>
                  </div>
                  
                  <div className="menu-detail-price">
                    <span>{t.price}</span>
                    <span>
                      {(() => {
                        const priceValue = menuItem.basePrice || menuItem[selectedLanguage]?.price || menuItem.ko?.price || menuItem.price;
                        const num = typeof priceValue === 'number'
                          ? priceValue
                          : parseInt(String(priceValue || '0').replace(/[^0-9]/g, '')) || 0;
                        return selectedLanguage === 'ko'
                          ? `${num.toLocaleString()}원`
                          : `₩${num.toLocaleString()}`;
                      })()}
                    </span>
                  </div>
                </div>
              </div>

              {menuItem.options && menuItem.menuType !== '고정세트' ? (
                <div className="options-list">
                  {(() => {
                    // Check if options is an array (new format) or object (legacy format)
                    const isArrayFormat = Array.isArray(menuItem.options);
                    
                    if (isArrayFormat) {
                      // New format: array of option groups
                      // hidden 플래그가 있는 옵션은 렌더링하지 않음 (고정세트의 구성품)
                      return menuItem.options
                        .filter(optionGroup => !optionGroup.hidden && !optionGroup.auto_include) // hidden/자동세트(02) 옵션은 시트에 표시 안 함
                        .map((optionGroup, groupIndex) => {
                        const countMode = isCountGroup(optionGroup);        // QTY>=2
                        const groupSelectN = getSelectN(optionGroup);        // N
                        const isRadioVisual = optionGroup.required && !countMode; // 라디오 원형 여부
                        return (
                        <div key={groupIndex} className="option-group">
                          <div className="option-group-header">
                            <span className="option-group-title">
                            {(() => {
                              // 언어별 옵션 그룹 이름 선택
                              // OKDC: option_group_name_ko/en/ja/zh
                              // Union POS: group_name_ko/en/ja/zh
                              if (selectedLanguage === 'ko') {
                                return optionGroup.option_group_name_ko || optionGroup.group_name_ko || optionGroup.name || optionGroup.option_group_name;
                              } else if (selectedLanguage === 'en') {
                                return optionGroup.option_group_name_en || optionGroup.group_name_en || optionGroup.name || optionGroup.option_group_name;
                              } else if (selectedLanguage === 'ja') {
                                return optionGroup.option_group_name_ja || optionGroup.group_name_ja || optionGroup.name || optionGroup.option_group_name;
                              } else if (selectedLanguage === 'zh') {
                                return optionGroup.option_group_name_zh || optionGroup.group_name_zh || optionGroup.name || optionGroup.option_group_name;
                              }
                              return optionGroup.name || optionGroup.option_group_name;
                            })()}
                            {countMode && <span className="option-group-count">({groupSelectN}개)</span>}
                            </span>
                            {(() => {
                              const langPath = selectedLanguage === 'en' ? 'english' : selectedLanguage === 'ja' ? 'japan' : selectedLanguage === 'zh' ? 'china' : 'korean';
                              // DB의 required 값 사용 (is_required 컬럼 값)
                              const isRequired = optionGroup.required;
                              const tagType = isRequired ? 'requiredTag' : 'optionalTag';
                              const tagUrl = menutagMap[langPath]?.[tagType];

                              return (
                                <img
                                  src={tagUrl}
                                  alt={isRequired ? '필수' : '선택'}
                                  style={{ height: '22px', width: 'auto', objectFit: 'contain' }}
                                />
                              );
                            })()}
                          </div>

                          <div className="option-items">
                            {(() => {
                              const items = optionGroup.choices || optionGroup.items || [];
                              return items;
                            })().map((choice, itemIndex) => (
                              <label
                                key={itemIndex}
                                className={`option-item${countMode && !selectedOptions[`${optionGroup.name || optionGroup.option_group_name}_${itemIndex}`] && groupSelectedCount(optionGroup, selectedOptions) >= groupSelectN ? ' option-item--disabled' : ''}`}
                                onMouseDown={(e) => {
                                  // 마우스 다운 시 리플 시작
                                  if (!('ontouchstart' in window)) {
                                    hasMoved.current = false;
                                    // 스크롤이 막 끝났을 때를 대비해 스크롤 상태 체크
                                    if (scrollTimeoutRef.current) {
                                      clearTimeout(scrollTimeoutRef.current);
                                      setIsScrolling(false);
                                    }
                                  }
                                }}
                                onMouseUp={(e) => {
                                  // 마우스 업 시 리플 생성 및 옵션 선택
                                  if (rippleTimeoutRef.current) {
                                    clearTimeout(rippleTimeoutRef.current);
                                  }
                                  
                                  if (!hasMoved.current && !isScrolling && !('ontouchstart' in window)) {
                                    // 리플 생성
                                    const fakeEvent = { clientX: e.clientX, clientY: e.clientY };
                                    createRipple(e.currentTarget, fakeEvent);
                                    
                                    // 옵션 선택 처리 (즉시 실행)
                                    // DB의 required 값으로 라디오/체크박스 결정
                                    const optionType = countMode ? 'count' : (optionGroup.required ? 'radio' : 'checkbox');
                                    const optionKey = `${optionGroup.name || optionGroup.option_group_name}_${itemIndex}`;

                                    // count 모드(QTY>=2): 이미 N개 선택됐고 이 항목이 미선택이면 선택 차단
                                    const blockedByCount = optionType === 'count'
                                      && !selectedOptions[optionKey]
                                      && groupSelectedCount(optionGroup, selectedOptions) >= groupSelectN;

                                    if (!blockedByCount) {
                                    // 애니메이션 트리거
                                    if (optionType === 'radio') {
                                      setRadioAnimating(optionKey);
                                      setTimeout(() => setRadioAnimating(null), 300);
                                    } else {
                                      setCheckboxAnimating(optionKey);
                                      setTimeout(() => setCheckboxAnimating(null), 200);
                                    }

                                    setSelectedOptions(prev => {
                                      const newOptions = { ...prev };

                                      if (optionType === 'radio') {
                                        // 라디오: 같은 그룹의 다른 옵션들을 해제하고 현재 항목 선택
                                        const groupPrefix = optionGroup.name || optionGroup.option_group_name;
                                        Object.keys(newOptions).forEach(key => {
                                          if (key.startsWith(`${groupPrefix}_`)) {
                                            delete newOptions[key];
                                          }
                                        });
                                        newOptions[optionKey] = choice;
                                      } else {
                                        // 체크박스/count: 토글 (count 상한은 위 blockedByCount 에서 이미 차단)
                                        if (newOptions[optionKey]) {
                                          delete newOptions[optionKey];
                                        } else {
                                          newOptions[optionKey] = choice;
                                        }
                                      }

                                      return newOptions;
                                    });
                                    }
                                  }
                                }}
                                onMouseMove={(e) => {
                                  // 마우스 이동 감지
                                  if (!hasMoved.current && !('ontouchstart' in window)) {
                                    hasMoved.current = true;
                                  }
                                }}
                                onTouchStart={(e) => {
                                  // 터치 시작
                                  hasMoved.current = false;
                                }}
                                onTouchMove={(e) => {
                                  // 터치가 움직이면 무조건 스크롤로 간주
                                  hasMoved.current = true;
                                  if (rippleTimeoutRef.current) {
                                    clearTimeout(rippleTimeoutRef.current);
                                  }
                                  // 스크롤 시 리플 제거
                                  const ripples = e.currentTarget.querySelectorAll('.ripple');
                                  ripples.forEach(ripple => ripple.remove());
                                }}
                                onTouchEnd={(e) => {
                                  // 터치 종료 시 옵션 선택
                                  if (rippleTimeoutRef.current) {
                                    clearTimeout(rippleTimeoutRef.current);
                                  }
                                  
                                  // 스크롤하지 않고, 이동이 적은 경우 선택
                                  if (!isScrolling && !hasMoved.current) {
                                    const touch = e.changedTouches[0];
                                    
                                    // 리플 생성
                                    createRipple(e.currentTarget, touch);
                                    
                                    // 옵션 선택 처리 (즉시 실행)
                                    // DB의 required 값으로 라디오/체크박스 결정
                                    const optionType = countMode ? 'count' : (optionGroup.required ? 'radio' : 'checkbox');
                                    const optionKey = `${optionGroup.name || optionGroup.option_group_name}_${itemIndex}`;

                                    // count 모드(QTY>=2): 이미 N개 선택됐고 이 항목이 미선택이면 선택 차단
                                    const blockedByCount = optionType === 'count'
                                      && !selectedOptions[optionKey]
                                      && groupSelectedCount(optionGroup, selectedOptions) >= groupSelectN;

                                    if (!blockedByCount) {
                                    // 애니메이션 트리거
                                    if (optionType === 'radio') {
                                      setRadioAnimating(optionKey);
                                      setTimeout(() => setRadioAnimating(null), 300);
                                    } else {
                                      setCheckboxAnimating(optionKey);
                                      setTimeout(() => setCheckboxAnimating(null), 200);
                                    }

                                    setSelectedOptions(prev => {
                                      const newOptions = { ...prev };

                                      if (optionType === 'radio') {
                                        // 라디오: 같은 그룹의 다른 옵션들을 해제하고 현재 항목 선택
                                        const groupPrefix = optionGroup.name || optionGroup.option_group_name;
                                        Object.keys(newOptions).forEach(key => {
                                          if (key.startsWith(`${groupPrefix}_`)) {
                                            delete newOptions[key];
                                          }
                                        });
                                        newOptions[optionKey] = choice;
                                      } else {
                                        // 체크박스/count: 토글 (count 상한은 위 blockedByCount 에서 이미 차단)
                                        if (newOptions[optionKey]) {
                                          delete newOptions[optionKey];
                                        } else {
                                          newOptions[optionKey] = choice;
                                        }
                                      }

                                      return newOptions;
                                    });
                                    }
                                  }
                                  
                                  hasMoved.current = false;
                                }}
                              >
                                <div className="option-select-wrapper">
                                  <input
                                    type={isRadioVisual ? "radio" : "checkbox"}
                                    name={`option-${groupIndex}`}
                                    value={choice.name || choice.option_name}
                                    onChange={() => {}}
                                    checked={!!selectedOptions[`${optionGroup.name || optionGroup.option_group_name}_${itemIndex}`]}
                                    style={{ display: 'none' }}
                                  />
                                  <div className={isRadioVisual ? 'option-radio' : 'option-checkbox'}>
                                    {isRadioVisual ? (
                                      // 라디오 버튼
                                      <div className={`radio-wrapper ${selectedOptions[`${optionGroup.name || optionGroup.option_group_name}_${itemIndex}`] ? 'selected' : ''} ${radioAnimating === `${optionGroup.name || optionGroup.option_group_name}_${itemIndex}` ? 'animating' : ''}`}>
                                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          {/* 노란색 배경 */}
                                          <circle cx="9.5" cy="9.5" r="9.5" className="radio-bg" fill="#FDCD27"/>
                                          {/* 흰색 내부 원 */}
                                          <circle cx="9.5" cy="9.5" r="4.5" className="radio-center" fill="white"/>
                                          {/* 회색 테두리 */}
                                          <circle cx="9.5" cy="9.5" r="8" className="radio-border" stroke="#DDDDDD" strokeWidth={2} fill="none" transformOrigin="center"/>
                                        </svg>
                                      </div>
                                    ) : (
                                      // 체크박스
                                      <div className={`checkbox-wrapper ${selectedOptions[`${optionGroup.name || optionGroup.option_group_name}_${itemIndex}`] ? 'selected' : ''} ${checkboxAnimating === `${optionGroup.name || optionGroup.option_group_name}_${itemIndex}` ? 'animating' : ''}`}>
                                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <defs>
                                            <mask id={`checkbox-mask-${groupIndex}-${itemIndex}`}>
                                              <rect x="-19" y="0" width="19" height="19" fill="white" className="checkbox-mask-rect"/>
                                            </mask>
                                          </defs>
                                          {/* 노란색 배경 (항상 보이지만 흰색 사각형에 가려짐) */}
                                          <rect x="0" y="0" width="19" height="19" rx="4" fill="#FDCD27"/>
                                          {/* 흰색 내부 사각형 (크기가 변하면서 노란색을 드러냄) */}
                                          <rect x="0" y="0" width="19" height="19" rx="4" className="checkbox-white" fill="white"/>
                                          {/* 체크마크 */}
                                          <path className="checkbox-mark" d="M14.7583 5.27726C14.9131 5.45463 15 5.69518 15 5.94599C15 6.19681 14.9131 6.43735 14.7583 6.61473L8.5713 13.7044C8.48954 13.7981 8.39247 13.8725 8.28563 13.9232C8.17879 13.9739 8.06428 14 7.94864 14C7.83299 14 7.71848 13.9739 7.61165 13.9232C7.50481 13.8725 7.40774 13.7981 7.32597 13.7044L4.252 10.1826C4.17316 10.0953 4.11028 9.99096 4.06702 9.87556C4.02375 9.76016 4.00098 9.63604 4.00003 9.51044C3.99908 9.38485 4.01996 9.2603 4.06147 9.14405C4.10297 9.02781 4.16427 8.9222 4.24177 8.83339C4.31927 8.74458 4.41144 8.67434 4.51288 8.62678C4.61433 8.57922 4.72302 8.55529 4.83262 8.55638C4.94223 8.55747 5.05054 8.58357 5.15125 8.63314C5.25196 8.68271 5.34304 8.75477 5.41919 8.84511L7.94836 11.7433L13.5906 5.27726C13.6672 5.18936 13.7583 5.11963 13.8584 5.07206C13.9586 5.02449 14.066 5 14.1745 5C14.2829 5 14.3903 5.02449 14.4905 5.07206C14.5906 5.11963 14.6817 5.18936 14.7583 5.27726Z" fill="white" fillRule="evenodd" clipRule="evenodd" mask={`url(#checkbox-mask-${groupIndex}-${itemIndex})`}/>
                                          {/* 회색 테두리 */}
                                          <rect x="1" y="1" width="17" height="17" rx="3" className="checkbox-border" stroke="#DDDDDD" strokeWidth={2} fill="none"/>
                                        </svg>
                                      </div>
                                    )}
                                  </div>
                                  <span className="option-name">
                                    {(() => {
                                      // 언어별 옵션 선택지 이름 선택
                                      // OKDC는 다국어 지원 안함 (option_name만 사용)
                                      // Union POS는 다국어 지원 (option_name_ko, name 등 사용)
                                      if (selectedLanguage === 'ko') {
                                        return choice.option_name_ko || choice.name || choice.option_name;
                                      } else if (selectedLanguage === 'en') {
                                        return choice.option_name_en || choice.name || choice.option_name;
                                      } else if (selectedLanguage === 'ja') {
                                        return choice.option_name_ja || choice.name || choice.option_name;
                                      } else if (selectedLanguage === 'zh') {
                                        return choice.option_name_zh || choice.name || choice.option_name;
                                      }
                                      return choice.name || choice.option_name;
                                    })()}
                                  </span>
                                </div>
                                <span className="option-price">
                                  {(() => {
                                    // 선택 메뉴는 실제 가격 표시
                                    const isChoiceType = menuItem?.menuType === '선택';
                                    let displayPrice = 0;

                                    if (isChoiceType && actualPrices[choice.itemCode]) {
                                      // DB에서 조회한 실제 가격 사용
                                      displayPrice = actualPrices[choice.itemCode];
                                    } else {
                                      // 일반 메뉴는 옵션에 설정된 추가 가격 사용
                                      displayPrice = parseInt(choice.price || choice.option_price || '0');
                                    }

                                    if (displayPrice > 0) {
                                      return selectedLanguage === 'ko'
                                        ? `${isChoiceType ? '' : '+'}${displayPrice.toLocaleString()}원`
                                        : `${isChoiceType ? '' : '+'} ₩${displayPrice.toLocaleString()}`;
                                    } else {
                                      return selectedLanguage === 'ko' ? '0원' : '₩0';
                                    }
                                  })()}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>
                      ); })
                    } else {
                      // Legacy format: object with group names as keys
                      return Object.entries(menuItem.options).map(([groupTitle, groupData], groupIndex) => (
                        <div key={groupIndex} className="option-group">
                          <div className="option-group-header">
                            {groupTitle}
                            {(() => {
                              const langPath = selectedLanguage === 'en' ? 'english' : selectedLanguage === 'ja' ? 'japan' : selectedLanguage === 'zh' ? 'china' : 'korean';
                              const tagType = groupData.type === 'required' ? 'requiredTag' : 'optionalTag';
                              const tagUrl = menutagMap[langPath]?.[tagType];

                              return (
                                <img
                                  src={tagUrl}
                                  alt={groupData.type === 'required' ? '필수' : '선택'}
                                  style={{ height: '22px', width: 'auto', objectFit: 'contain' }}
                                />
                              );
                            })()}
                          </div>
                          
                          <div className="option-items">
                            {groupData.items.map((item, itemIndex) => (
                          <label 
                            key={itemIndex} 
                            className="option-item"
                            onMouseDown={(e) => {
                              // 마우스 다운 시 리플 시작
                              if (!('ontouchstart' in window)) {
                                hasMoved.current = false;
                                // 스크롤이 막 끝났을 때를 대비해 스크롤 상태 체크
                                if (scrollTimeoutRef.current) {
                                  clearTimeout(scrollTimeoutRef.current);
                                  setIsScrolling(false);
                                }
                              }
                            }}
                            onMouseUp={(e) => {
                              // 마우스 업 시 리플 생성 및 옵션 선택
                              if (rippleTimeoutRef.current) {
                                clearTimeout(rippleTimeoutRef.current);
                              }
                              if (!('ontouchstart' in window) && !isScrolling && !hasMoved.current) {
                                createRipple(e.currentTarget, e);
                                handleOptionChange(groupIndex, item.name, groupData.type === 'optional');
                              }
                            }}
                            onMouseLeave={() => {
                              // 마우스가 벗어나면 취소
                              if (rippleTimeoutRef.current) {
                                clearTimeout(rippleTimeoutRef.current);
                              }
                              hasMoved.current = true;
                            }}
                            onTouchStart={(e) => {
                              // 터치 시작
                              hasMoved.current = false;
                            }}
                            onTouchMove={(e) => {
                              // 터치가 움직이면 무조건 스크롤로 간주
                              hasMoved.current = true;
                              if (rippleTimeoutRef.current) {
                                clearTimeout(rippleTimeoutRef.current);
                              }
                              // 스크롤 시 리플 제거
                              const ripples = e.currentTarget.querySelectorAll('.ripple');
                              ripples.forEach(ripple => ripple.remove());
                            }}
                            onTouchEnd={(e) => {
                              // 터치 종료 시 옵션 선택
                              if (rippleTimeoutRef.current) {
                                clearTimeout(rippleTimeoutRef.current);
                              }
                              
                              // 스크롤하지 않고, 이동이 적은 경우 선택
                              if (!isScrolling && !hasMoved.current) {
                                const touch = e.changedTouches[0];
                                createRipple(e.currentTarget, touch);
                                handleOptionChange(groupIndex, item.name, groupData.type === 'optional');
                              }
                              
                              hasMoved.current = false;
                            }}
                          >
                            <div className="option-select-wrapper">
                              <input
                                type={groupData.type === 'optional' ? "checkbox" : "radio"}
                                name={`option-${groupIndex}`}
                                value={item.name}
                                onChange={() => {}}
                                checked={
                                  groupData.type === 'optional' 
                                    ? (selectedOptions[groupIndex] || []).includes(item.name)
                                    : selectedOptions[groupIndex] === item.name
                                }
                                style={{ display: 'none' }}
                              />
                              <div className={groupData.type === 'required' ? 'option-radio' : 'option-checkbox'}>
                                {groupData.type === 'required' ? (
                                  // 라디오 버튼
                                  <div className={`radio-wrapper ${selectedOptions[groupIndex] === item.name ? 'selected' : ''} ${radioAnimating === `${groupIndex}-${item.name}` ? 'animating' : ''}`}>
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      {/* 노란색 배경 */}
                                      <circle cx="9.5" cy="9.5" r="9.5" className="radio-bg" fill="#FDCD27"/>
                                      {/* 흰색 내부 원 */}
                                      <circle cx="9.5" cy="9.5" r="4.5" className="radio-center" fill="white"/>
                                      {/* 회색 테두리 */}
                                      <circle cx="9.5" cy="9.5" r="8" className="radio-border" stroke="#DDDDDD" strokeWidth={2} fill="none" transformOrigin="center"/>
                                    </svg>
                                  </div>
                                ) : (
                                  // 체크박스
                                  <div className={`checkbox-wrapper ${(selectedOptions[groupIndex] || []).includes(item.name) ? 'selected' : ''} ${checkboxAnimating === `${groupIndex}-${item.name}` ? 'animating' : ''}`}>
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <defs>
                                        <mask id={`checkbox-mask-${groupIndex}-${itemIndex}`}>
                                          <rect x="-19" y="0" width="19" height="19" fill="white" className="checkbox-mask-rect"/>
                                        </mask>
                                      </defs>
                                      {/* 노란색 배경 (항상 보이지만 흰색 사각형에 가려짐) */}
                                      <rect x="0" y="0" width="19" height="19" rx="4" fill="#FDCD27"/>
                                      {/* 흰색 내부 사각형 (크기가 변하면서 노란색을 드러냄) */}
                                      <rect x="0" y="0" width="19" height="19" rx="4" className="checkbox-white" fill="white"/>
                                      {/* 체크마크 */}
                                      <path className="checkbox-mark" d="M14.7583 5.27726C14.9131 5.45463 15 5.69518 15 5.94599C15 6.19681 14.9131 6.43735 14.7583 6.61473L8.5713 13.7044C8.48954 13.7981 8.39247 13.8725 8.28563 13.9232C8.17879 13.9739 8.06428 14 7.94864 14C7.83299 14 7.71848 13.9739 7.61165 13.9232C7.50481 13.8725 7.40774 13.7981 7.32597 13.7044L4.252 10.1826C4.17316 10.0953 4.11028 9.99096 4.06702 9.87556C4.02375 9.76016 4.00098 9.63604 4.00003 9.51044C3.99908 9.38485 4.01996 9.2603 4.06147 9.14405C4.10297 9.02781 4.16427 8.9222 4.24177 8.83339C4.31927 8.74458 4.41144 8.67434 4.51288 8.62678C4.61433 8.57922 4.72302 8.55529 4.83262 8.55638C4.94223 8.55747 5.05054 8.58357 5.15125 8.63314C5.25196 8.68271 5.34304 8.75477 5.41919 8.84511L7.94836 11.7433L13.5906 5.27726C13.6672 5.18936 13.7583 5.11963 13.8584 5.07206C13.9586 5.02449 14.066 5 14.1745 5C14.2829 5 14.3903 5.02449 14.4905 5.07206C14.5906 5.11963 14.6817 5.18936 14.7583 5.27726Z" fill="white" fillRule="evenodd" clipRule="evenodd" mask={`url(#checkbox-mask-${groupIndex}-${itemIndex})`}/>
                                      {/* 회색 테두리 */}
                                      <rect x="1" y="1" width="17" height="17" rx="3" className="checkbox-border" stroke="#DDDDDD" strokeWidth={2} fill="none"/>
                                    </svg>
                                  </div>
                                )}
                              </div>
                              <span className="option-name">{item.name}</span>
                            </div>
                            <span className="option-price">
                              {item.price > 0 
                                ? (selectedLanguage === 'ko' 
                                    ? `+${item.price.toLocaleString()}원` 
                                    : `+ ₩${item.price.toLocaleString()}`
                                  )
                                : (selectedLanguage === 'ko' ? '+0원' : '+ ₩0')
                              }
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  ));
                    }
                  })()}
                </div>
              ) : null}

              <div className="quantity-section">
                <div className="quantity-header">
                  <h3>{t.quantity}</h3>
                  <div className="quantity-selector">
                    <button 
                      className="quantity-button minus"
                      onClick={() => {
                        if (!isQuantityAnimating && quantity > 1) {
                          // 진동 효과
                          if (navigator.vibrate) {
                            navigator.vibrate(20);
                          }
                          handleQuantityChange(quantity - 1, 'up');
                        }
                      }}
                      disabled={quantity <= 1}
                    >
                      <svg width="11" height="2" viewBox="0 0 11 2" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)' }}>
                        <rect y="0.388916" width="11" height="1.22222" rx="0.611111" fill="#000000"/>
                      </svg>
                    </button>
                    <div className="quantity-display">
                      <div className="quantity-text-container">
                        {isQuantityAnimating && animationDirection && (
                          <div className={`quantity-text ${animationDirection === 'up' ? 'prev-up' : 'prev-down'}`} key={`prev-${prevQuantity}`}>
                            {prevQuantity}
                          </div>
                        )}
                        <div className={`quantity-text ${isQuantityAnimating && animationDirection ? (animationDirection === 'up' ? 'current-up' : 'current-down') : ''}`} key={`current-${quantity}`}>
                          {quantity}
                        </div>
                      </div>
                    </div>
                    <button 
                      className="quantity-button plus"
                      onClick={() => {
                        if (!isQuantityAnimating) {
                          // 진동 효과
                          if (navigator.vibrate) {
                            navigator.vibrate(20);
                          }
                          handleQuantityChange(quantity + 1, 'down');
                        }
                      }}
                    >
                      <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)' }}>
                        <rect y="5.38892" width="11" height="1.22222" rx="0.611111" fill="#000000"/>
                        <rect x="6.11108" y="0.5" width="11" height="1.22222" rx="0.611111" transform="rotate(90 6.11108 0.5)" fill="#000000"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              
              <div className="gray-spacer"></div>
            </div>

            <div className="options-fixed-bottom">
              <button className="options-bottom-button" onClick={handleAddToCart} disabled={!isOptionSelectionValid()} style={{ gap: selectedLanguage === 'en' || selectedLanguage === 'ja' || selectedLanguage === 'zh' ? '4px' : '11px' }}>
                {/* 영어일 때 Add 텍스트를 먼저 표시 */}
                {selectedLanguage === 'en' && (
                  <span>{t.add}</span>
                )}
                <div className="price-slot-container">
                  {/* 해외 언어일 때 ₩ 표시 */}
                  {selectedLanguage !== 'ko' && (
                    <span className="price-prefix">₩</span>
                  )}
                  {(() => {
                    // 가격 포맷팅 함수
                    const formatPriceForAnimation = (price) => {
                      // 쉼표 제거하고 숫자만 추출
                      const numStr = price.replace(/,/g, '');
                      // 자릿수별로 배열로 변환 (예: "100000" -> ["1", "0", "0", ",", "0", "0", "0"])
                      const result = [];
                      for (let i = 0; i < numStr.length; i++) {
                        if (i > 0 && (numStr.length - i) % 3 === 0) {
                          result.push(',');
                        }
                        result.push(numStr[i]);
                      }
                      return result;
                    };
                    
                    const currentPriceArray = formatPriceForAnimation(displayPrice);
                    const prevPriceArray = formatPriceForAnimation(prevPrice);
                    
                    // 더 긴 길이에 맞춰 정렬 (뒤에서부터)
                    const maxLength = Math.max(currentPriceArray.length, prevPriceArray.length);
                    const alignedCurrent = Array(maxLength).fill(' ');
                    const alignedPrev = Array(maxLength).fill(' ');
                    
                    // 뒤에서부터 채우기
                    for (let i = 0; i < currentPriceArray.length; i++) {
                      alignedCurrent[maxLength - currentPriceArray.length + i] = currentPriceArray[i];
                    }
                    for (let i = 0; i < prevPriceArray.length; i++) {
                      alignedPrev[maxLength - prevPriceArray.length + i] = prevPriceArray[i];
                    }
                    
                    return alignedCurrent.map((digit, index) => {
                      const prevDigit = alignedPrev[index];
                      const isNewSlot = prevDigit === ' ' && digit !== ' ';
                      const isRemovedSlot = prevDigit !== ' ' && digit === ' ';
                      const isChanged = priceAnimating && prevDigit !== digit && !isNewSlot && !isRemovedSlot;
                      
                      // 쉼표는 애니메이션 없이 처리
                      if (digit === ',') {
                        return (
                          <div key={`${index}-${animationKey}-comma`} className="digit-container comma">
                            <span className={`digit ${isNewSlot ? 'digit-fade-in' : ''}`}>,</span>
                          </div>
                        );
                      }
                      
                      // 빈 공간은 새 슬롯이 아니면 렌더링하지 않음
                      if (digit === ' ' && !isNewSlot && !priceAnimating) {
                        return null;
                      }
                      
                      // 중간 숫자 생성 (개선된 로직)
                      const generateSmoothIntermediates = () => {
                        if (!isChanged || isNaN(prevDigit) || isNaN(digit) || prevDigit === ' ' || digit === ' ') {
                          return [];
                        }
                        
                        const from = parseInt(prevDigit);
                        const to = parseInt(digit);
                        const diff = Math.abs(to - from);
                        
                        // 차이가 5 이상이면 빠른 롤링 효과
                        if (diff >= 5) {
                          const intermediates = [];
                          if (isPriceIncreasing) {
                            // 증가: 0-9 순환
                            for (let i = 0; i < 3; i++) {
                              intermediates.push((from + i + 1) % 10);
                            }
                          } else {
                            // 감소: 9-0 순환
                            for (let i = 0; i < 3; i++) {
                              intermediates.push((from - i - 1 + 10) % 10);
                            }
                          }
                          return intermediates;
                        }
                        
                        // 차이가 작으면 실제 중간값
                        const intermediates = [];
                        if (from < to) {
                          for (let i = from + 1; i < to; i++) {
                            intermediates.push(i);
                          }
                        } else {
                          for (let i = from - 1; i > to; i--) {
                            intermediates.push(i);
                          }
                        }
                        return intermediates;
                      };
                      
                      const intermediateDigits = generateSmoothIntermediates();
                      const animationDelay = index * 30; // 각 자릿수마다 30ms 딜레이
                      
                      return (
                        <div key={`${index}-${animationKey}`} className={`digit-container ${isNewSlot ? 'slot-appearing' : ''} ${isRemovedSlot ? 'slot-disappearing' : ''}`}>
                          {/* 이전 숫자 (사라지는 애니메이션) */}
                          {isChanged && prevDigit !== ' ' && (
                            <span 
                              className={`digit ${isPriceIncreasing ? 'digit-exit-up' : 'digit-exit'}`}
                              style={{ animationDelay: `${animationDelay}ms` }}
                            >
                              {prevDigit}
                            </span>
                          )}
                          
                          {/* 중간 숫자들 */}
                          {intermediateDigits.map((intermediateDigit, i) => (
                            <span
                              key={`intermediate-${i}`}
                              className={`digit ${isPriceIncreasing ? 'digit-intermediate-up' : 'digit-intermediate'}`}
                              style={{ 
                                animationDelay: `${animationDelay + (i + 1) * 50}ms`,
                                animationDuration: '50ms'
                              }}
                            >
                              {intermediateDigit}
                            </span>
                          ))}
                          
                          {/* 현재 숫자 */}
                          {digit !== ' ' && (
                            <span 
                              className={`digit ${isChanged ? (isPriceIncreasing ? 'digit-enter-up' : 'digit-enter') : ''} ${isNewSlot ? 'digit-fade-in' : ''}`}
                              style={isChanged ? { animationDelay: `${animationDelay + (intermediateDigits.length * 50) + 50}ms` } : isNewSlot ? { animationDelay: `${animationDelay}ms` } : {}}
                            >
                              {digit}
                            </span>
                          )}
                        </div>
                      );
                    }).filter(Boolean);
                  })()}
                    {/* 한국어일 때 원 표시 */}
                    {selectedLanguage === 'ko' && (
                      <span className="price-suffix">원 담기</span>
                    )}
                  </div>
                  {/* 일본어일 때 追加 텍스트 표시 */}
                  {selectedLanguage === 'ja' && (
                    <span>{t.add}</span>
                  )}
                  {/* 중국어일 때 放入购物车 텍스트 표시 */}
                  {selectedLanguage === 'zh' && (
                    <span>{t.add}</span>
                  )}
              </button>
            </div>
          </>
        )}
      </div>

      <style jsx="true">{`
        
        .bottom-sheet {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: white;
          z-index: 1000;
          transform: translateX(100%);
          transition: transform 0.15s cubic-bezier(0.4, 0.0, 0.2, 1);
          display: flex;
          flex-direction: column;
          overflow: hidden;
          will-change: transform;
          overscroll-behavior: none;
          -webkit-overflow-scrolling: auto;
        }

        .bottom-sheet.open {
          transform: translateX(0);
        }

        .bottom-sheet-wrapper {
          width: 360px;
          height: 100%;
          margin: 0 auto;
          position: relative;
          display: flex;
          flex-direction: column;
          transform-origin: top center;
          overscroll-behavior: none;
        }
        
        @media screen and (min-width: 361px) {
          .bottom-sheet-wrapper {
            zoom: calc(100vw / 360);
          }
        }
        
        @media screen and (min-width: 540px) {
          .bottom-sheet-wrapper {
            zoom: 1.5;
          }
        }
        
        @media screen and (max-width: 360px) {
          .bottom-sheet-wrapper {
            width: 100vw;
            zoom: calc(100vw / 360);
          }
        }

        .bottom-sheet-content {
          flex: 1;
          overflow-y: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
          overscroll-behavior: none;
          -webkit-overflow-scrolling: auto;
          touch-action: pan-y;
          background-color: #F3F5F7;
        }
        
        .bottom-sheet-content::-webkit-scrollbar {
          display: none;
        }

        .menu-detail-section {
          border-bottom: 10px solid #F3F5F7;
          background-color: white;
        }

        .menu-image-large {
          width: 100%;
          height: 200px;
          overflow: hidden;
        }

        .menu-image-large img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .menu-detail-info {
          padding: 20px 16px 24px;
        }

        .menu-tags-detail {
          display: flex;
          gap: 6px;
          margin-top: 20px;
          margin-bottom: 10px;
        }

        .menu-tag-detail {
          height: 20px;
          width: auto;
        }

        .menu-text-wrapper {
          margin-top: 0;
        }
        
        .menu-tags-detail + .menu-text-wrapper {
          margin-top: 0;
        }

        .menu-detail-name {
          font-size: 22px;
          font-weight: 700;
          margin: 0 0 8px 0;
        }

        .menu-detail-description {
          font-size: 14px;
          color: #666;
          margin: 0;
          word-wrap: break-word;
          word-break: break-word;
          white-space: normal;
          overflow-wrap: break-word;
        }

        .menu-detail-price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 17px;
          font-weight: 700;
          margin: 32px 0 0 0;
        }

        .options-list {
          background-color: white;
        }

        .option-group {
          padding: 20px 0 8px;
          border-bottom: 1px solid #f0f0f0;
        }

        .option-group:last-child {
          padding-bottom: 19px;
          border-bottom: 10px solid #F3F5F7;
        }

        .option-group-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0px 16px 12px 16px;
          font-weight: 700;
          font-size: 18px;
        }

        .option-group-title {
          display: inline-flex;
          align-items: baseline;
          gap: 6px;
        }

        .option-group-count {
          font-size: 14px;
          font-weight: 600;
          color: #999999;
        }



        .option-items {
          display: flex;
          flex-direction: column;
        }

        .option-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 17px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          -webkit-tap-highlight-color: transparent;
        }

        /* count 모드(QTY>=2)에서 N개 다 선택되면 미선택 항목 흐리게 (선택 불가 표시) */
        .option-item--disabled {
          opacity: 0.4;
        }

        .option-select-wrapper {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        
        .option-radio, .option-checkbox {
          width: 19px;
          height: 19px;
          flex-shrink: 0;
        }
        
        .radio-wrapper {
          width: 19px;
          height: 19px;
          position: relative;
          overflow: hidden;
        }
        
        .radio-wrapper svg {
          overflow: visible;
        }
        
        .radio-wrapper.animating {
          animation: radioScale 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        @keyframes radioScale {
          0% {
            transform: scale(1);
          }
          40% {
            transform: scale(0.9);
          }
          100% {
            transform: scale(1);
          }
        }
        
        /* Off 상태 (기본) */
        .radio-border {
          opacity: 1;
          transform: scale(1);
          transform-origin: center;
          transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1), transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .radio-bg {
          transform: scale(0);
          transform-origin: center;
          transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .radio-center {
          transform: scale(2.11); /* 9.5 / 4.5 = 2.11 */
          transform-origin: center;
          transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        /* On 상태 (선택됨) */
        .radio-wrapper.selected .radio-border {
          opacity: 0;
          transform: scale(0);
        }
        
        .radio-wrapper.selected .radio-bg {
          transform: scale(1);
        }
        
        .radio-wrapper.selected .radio-center {
          transform: scale(1);
        }
        
        /* 체크박스 스타일 */
        .checkbox-wrapper {
          width: 19px;
          height: 19px;
          position: relative;
          overflow: hidden;
        }
        
        .checkbox-wrapper.animating {
          animation: checkboxScale 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        @keyframes checkboxScale {
          0% {
            transform: scale(1);
          }
          40% {
            transform: scale(0.9);
          }
          100% {
            transform: scale(1);
          }
        }
        
        .checkbox-wrapper svg {
          overflow: visible;
        }
        
        /* Off 상태 (기본) */
        .checkbox-border {
          opacity: 1;
          transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .checkbox-white {
          transform: scale(1);
          transform-origin: center;
          transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .checkbox-mask-rect {
          transform: translateX(0);
          transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0.1s;
        }
        
        .checkbox-mark {
          opacity: 1;
        }
        
        /* On 상태 (선택됨) */
        .checkbox-wrapper.selected .checkbox-border {
          opacity: 0;
        }
        
        .checkbox-wrapper.selected .checkbox-white {
          transform: scale(0);
        }
        
        .checkbox-wrapper.selected .checkbox-mask-rect {
          transform: translateX(19px);
        }
        
        /* Off로 돌아갈 때 */
        .checkbox-wrapper:not(.selected) .checkbox-mask-rect {
          transform: translateX(0);
          transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .option-name {
          font-size: 14px;
          font-weight: 400;
          color: #000000;
        }

        .option-price {
          font-size: 14px;
          font-weight: 600;
          color: #000000;
          flex-shrink: 0;
          font-variant-numeric: tabular-nums;
        }

        .quantity-section {
          padding: 20px;
          background-color: white;
        }
        
        .gray-spacer {
          width: 100%;
          height: 100px;
          background-color: #F3F5F7;
        }

        .quantity-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .quantity-section h3 {
          font-size: 18px;
          font-weight: 700;
          margin: 0;
        }

        .quantity-selector {
          display: flex;
          align-items: center;
          width: 126px;
          height: 42px;
          background-color: #FFFFFF;
          border: 1px solid #D9D9D9;
          border-radius: 6px;
          position: relative;
          overflow: hidden;
        }
        
        .quantity-button {
          position: absolute;
          top: 0;
          width: 42px;
          height: 42px;
          border: none;
          background-color: transparent;
          cursor: pointer;
          z-index: 2;
          padding: 0;
        }
        
        .quantity-button.minus {
          left: 0;
        }
        
        .quantity-button.plus {
          right: 0;
        }
        
        .quantity-button svg, .quantity-button img {
          pointer-events: none;
        }
        
        .quantity-button::before {
          content: '';
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0);
          transition: background-color 0.2s;
        }
        
        .quantity-button.minus::before {
          left: 0;
        }
        
        .quantity-button.plus::before {
          right: 0;
        }
        
        .quantity-button:not(:disabled):active::before {
          animation: buttonFlash 0.2s ease-out;
        }
        
        @keyframes buttonFlash {
          0% {
            background-color: rgba(0, 0, 0, 0);
          }
          50% {
            background-color: rgba(0, 0, 0, 0.08);
          }
          100% {
            background-color: rgba(0, 0, 0, 0);
          }
        }
        
        .quantity-button:disabled {
          cursor: not-allowed;
        }
        
        .quantity-button:disabled svg, .quantity-button:disabled img {
          opacity: 0.3;
        }
        
        .quantity-display {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          user-select: none;
          position: relative;
          overflow: hidden;
          height: 42px;
        }
        
        .quantity-text-container {
          position: relative;
          height: 20px;
          width: 40px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        
        .quantity-text {
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: none;
          white-space: nowrap;
        }
        
        /* 위로 증가 애니메이션 */
        .quantity-text.current-up {
          animation: slideInFromTop 0.15s ease-out;
        }
        
        .quantity-text.prev-up {
          animation: slideOutToBottom 0.15s ease-out forwards;
        }
        
        /* 아래로 감소 애니메이션 */
        .quantity-text.current-down {
          animation: slideInFromBottom 0.15s ease-out;
        }
        
        .quantity-text.prev-down {
          animation: slideOutToTop 0.15s ease-out forwards;
        }
        
        @keyframes slideInFromTop {
          from {
            transform: translateY(-20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes slideOutToBottom {
          from {
            transform: translateY(0);
            opacity: 1;
          }
          to {
            transform: translateY(20px);
            opacity: 0;
            visibility: hidden;
          }
        }
        
        @keyframes slideInFromBottom {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes slideOutToTop {
          from {
            transform: translateY(0);
            opacity: 1;
          }
          to {
            transform: translateY(-20px);
            opacity: 0;
            visibility: hidden;
          }
        }

        .options-fixed-bottom {
          background-image: url(${bottomNavBg});
          position: fixed;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 360px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          padding-bottom: 16px;
          z-index: 1000;
          pointer-events: none; /* 전체 영역 클릭 불가 */
        }

        .options-bottom-button {
          width: 328px;
          height: 50px;
          background-color: #fdcd27;
          border-radius: 10px;
          border: none;
          font-size: 17px;
          font-weight: 700;
          color: #ffffff;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 11px;
          letter-spacing: -0.32px;
          line-height: 19px;
          transition: transform 0.12s cubic-bezier(0.4, 0.0, 0.2, 1), box-shadow 0.12s ease;
          pointer-events: auto; /* 버튼만 클릭 가능 */
        }

        .options-bottom-button:disabled {
          background-color: #E0E0E0;
          color: #FFFFFF;
          cursor: not-allowed;
        }

        .options-bottom-button:active {
          animation: buttonPress 0.15s ease-out;
        }
        
        @keyframes buttonPress {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(0.95);
          }
          100% {
            transform: scale(1);
          }
        }
        
        .price-slot-container {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0;
          overflow: hidden;
          height: 19px;
          position: relative;
        }
        
        .digit-container {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          height: 19px;
          min-width: 10px;
        }
        
        .digit-container.comma {
          min-width: 4px;
          margin: 0 1px;
        }
        
        .digit-container.slot-appearing {
          animation: slotAppear 0.3s ease-out;
        }
        
        .digit-container.slot-disappearing {
          animation: slotDisappear 0.3s ease-out forwards;
        }
        
        .digit {
          display: inline-block;
          line-height: 19px;
          transition: none;
          font-size: 17px;
          font-weight: 700;
          color: #ffffff;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
        
        .digit-fade-in {
          animation: digitFadeIn 0.3s ease-out both;
        }
        
        .digit-exit {
          position: absolute;
          animation: slideOutBottom 0.3s cubic-bezier(0.4, 0, 0.2, 1) both;
        }
        
        .digit-exit-up {
          position: absolute;
          animation: slideOutTop 0.3s cubic-bezier(0.4, 0, 0.2, 1) both;
        }
        
        .digit-enter {
          animation: slideInTop 0.3s cubic-bezier(0.4, 0, 0.2, 1) both;
        }
        
        .digit-enter-up {
          animation: slideInBottom 0.3s cubic-bezier(0.4, 0, 0.2, 1) both;
        }
        
        .digit-intermediate {
          position: absolute;
          animation: slideIntermediateQuick 100ms linear both;
        }
        
        .digit-intermediate-up {
          position: absolute;
          animation: slideIntermediateQuickUp 100ms linear both;
        }
        
        @keyframes slideInTop {
          from {
            transform: translateX(-50%) translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateX(-50%) translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes slideOutBottom {
          from {
            transform: translateX(-50%) translateY(0);
            opacity: 1;
          }
          to {
            transform: translateX(-50%) translateY(100%);
            opacity: 0;
          }
        }
        
        @keyframes slideInBottom {
          from {
            transform: translateX(-50%) translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateX(-50%) translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes slideOutTop {
          from {
            transform: translateX(-50%) translateY(0);
            opacity: 1;
          }
          to {
            transform: translateX(-50%) translateY(-100%);
            opacity: 0;
          }
        }
        
        @keyframes slideIntermediateQuick {
          0% {
            transform: translateX(-50%) translateY(-100%);
            opacity: 0.8;
          }
          50% {
            transform: translateX(-50%) translateY(0);
            opacity: 1;
          }
          100% {
            transform: translateX(-50%) translateY(100%);
            opacity: 0;
          }
        }
        
        @keyframes slideIntermediateQuickUp {
          0% {
            transform: translateX(-50%) translateY(100%);
            opacity: 0.8;
          }
          50% {
            transform: translateX(-50%) translateY(0);
            opacity: 1;
          }
          100% {
            transform: translateX(-50%) translateY(-100%);
            opacity: 0;
          }
        }
        
        @keyframes digitFadeIn {
          0% {
            opacity: 0;
            transform: translateX(-50%) scale(0.8);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) scale(1);
          }
        }
        
        @keyframes slotAppear {
          from {
            opacity: 0;
            transform: scale(0.5);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes slotDisappear {
          from {
            opacity: 1;
            transform: scale(1);
          }
          to {
            opacity: 0;
            transform: scale(0.5);
          }
        }
        
        .price-prefix {
          margin-right: 1px;
          font-size: 17px;
          font-weight: 700;
          color: #ffffff;
        }
        
        .price-suffix {
          margin-left: 2px;
          font-size: 17px;
          font-weight: 700;
          color: #ffffff;
        }

        .ripple {
          position: absolute;
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.1);
          transform: scale(0);
          opacity: 0;
          transform-origin: center center;
          pointer-events: none;
        }
        
        .ripple.click {
          animation: rippleClick 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        }
        
        .ripple.hold {
          animation: rippleHold 0.35s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        }
        
        .ripple-out {
          animation: rippleFadeOut 0.2s ease-out forwards;
        }
        
        @keyframes rippleClick {
          0% {
            transform: scale(0.4);
            opacity: 0.8;
          }
          30% {
            transform: scale(1.2);
            opacity: 0.6;
          }
          100% {
            transform: scale(2.5);
            opacity: 0;
          }
        }
        
        @keyframes rippleHold {
          0% {
            transform: scale(0.4);
            opacity: 0.8;
          }
          100% {
            transform: scale(2.5);
            opacity: 0.8;
          }
        }
        
        @keyframes rippleFadeOut {
          from {
            opacity: 0.8;
          }
          to {
            opacity: 0;
          }
        }
      `}</style>
      </div>
  );
};
export default MenuOptionsBottomSheet;